/* unplugin-vue-components disabled */import { render } from "./UnsubscribeEmailNotificationSuccess.vue?vue&type=template&id=1ae33482&scoped=true&ts=true"
import script from "./UnsubscribeEmailNotificationSuccess.vue?vue&type=script&lang=ts"
export * from "./UnsubscribeEmailNotificationSuccess.vue?vue&type=script&lang=ts"

import "./UnsubscribeEmailNotificationSuccess.vue?vue&type=style&index=0&id=1ae33482&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae33482"]])

export default __exports__